import { ChangeDetectorRef, Component, forwardRef, Input, OnChanges, OnInit } from '@angular/core';
import { FormControl, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';

import { InputBaseReactComponent } from './../input-base-react/input-base-react.component';

@Component({
  selector: 'app-input-rich-text-react',
  templateUrl: './input-rich-text-react.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputRichTextReactComponent),
      multi: true
    }
  ],
  styleUrls: ['./input-rich-text-react.component.scss']
})

export class InputRichTextReactComponent extends InputBaseReactComponent implements OnInit, OnChanges {

  @Input() tamanhoMaximo = 10;
  @Input() formGroup: any;
  @Input() showFontFormat = true;
  @Input() showTextDecorators = true;
  @Input() showListOptions = true;
  @Input() showAlignment = true;
  @Input() showHyperLink = true;
  @Input() showAttachImage = true;
  @Input() height = '200px';
  public quillFormGroup: FormGroup;

  constructor(
    protected cdRef: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.setAndUpdateValidators();

    const formField = (this.form !== undefined ? this.form.get(this.name) : undefined);
    const valor = (formField === undefined ? this.value : formField.value);

    this.quillFormGroup = new FormGroup({
      'quilleditor': new FormControl(valor)
    });
  }

  setData(value: string) {
    this.quillFormGroup.get('quilleditor').setValue(value);
  }

  ngOnChanges(): void {
    super.ngOnChanges();
    this.setAndUpdateValidators();
    if (this.quillFormGroup !== undefined) {
      if (this.form !== undefined) {
        this.quillFormGroup.get('quilleditor').setValue(this.form.get(this.name).value);
      }
    }
  }

  atualizarForm(corpo: any) {
    this.changeValue(corpo.html, false, false, false, true);
    this.value = corpo.html;
    this.cdRef.detectChanges();
  }

  obterTexto() {
    const formField = (this.form !== undefined ? this.form.get(this.name) : undefined);
    const valor = (formField === undefined ? this.value : formField.value);
    return valor;
  }
}
